import hexToRGB from 'web-app/util/hex-to-rgb';
export const defaultShadowConfiguration = {
    half: '',
    one: '',
    two: '',
    three: '',
    four: '',
    five: '',
    getShadow: () => '',
    color: '',
};
const getShadowSize = (shadow) => {
    switch (shadow) {
        case 'half':
            return 1;
        case 'two':
            return 4;
        case 'three':
            return 8;
        case 'four':
            return 16;
        case 'five':
            return 24;
        case 'one':
        default:
            return 2;
    }
};
const getShadowPosition = (shadow, direction) => {
    const size = getShadowSize(shadow);
    const blur = size * 2;
    const directionalSize = (direction === 'right' || direction === 'up' ? -1 : 1) * size;
    if (direction === 'right' || direction === 'left') {
        return `${directionalSize}px 0 ${blur}px 0`;
    }
    else {
        return `0 ${directionalSize}px ${blur}px 0`;
    }
};
const getShadow = (shadow, direction, shadowBlack) => {
    const position = getShadowPosition(shadow, direction);
    return `${position} ${shadowBlack}`;
};
const getShadows = (black) => {
    const rgbBlack = hexToRGB(black);
    if (!rgbBlack) {
        return defaultShadowConfiguration;
    }
    const shadowBlack = `rgba(${rgbBlack.r}, ${rgbBlack.g}, ${rgbBlack.b}, 0.1)`;
    return {
        half: getShadow('half', 'down', shadowBlack),
        one: getShadow('one', 'down', shadowBlack),
        two: getShadow('two', 'down', shadowBlack),
        three: getShadow('three', 'down', shadowBlack),
        four: getShadow('four', 'down', shadowBlack),
        five: getShadow('five', 'down', shadowBlack),
        getShadow: (shadow, direction) => getShadow(shadow, direction, shadowBlack),
        color: shadowBlack,
    };
};
export default getShadows;
